"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeviceCircuit = exports.KNOWN_DEVICES = void 0;
// List of known device types
exports.KNOWN_DEVICES = [
    'sump pump',
    'furnace',
    'dishwasher',
    'refrigerator',
    'space heater',
    'freezer',
    'heater',
    'security camera',
    'water heater',
    'hvac',
    'ac unit',
    'microwave',
    'washing machine',
    'dryer',
    'oven',
    'stove',
    'lights',
    'outlets',
    'pool',
    'spa',
];
/**
 * Determines if a circuit location is a device or a room based on its name
 * @param location The name/location of the circuit
 * @returns boolean true if the circuit is a device, false if it's a room
 */
function isDeviceCircuit(location) {
    if (!location)
        return false;
    const normalizedLocation = location.toLowerCase().trim();
    // Check if the location includes any known device names
    return exports.KNOWN_DEVICES.some((device) => normalizedLocation.includes(device));
}
exports.isDeviceCircuit = isDeviceCircuit;
